import React, { useState, useEffect } from 'react';
import { supabase } from '../services/supabase';
import { toast } from 'react-toastify';
import { Transition, Dialog, Menu } from '@headlessui/react';
import { Fragment } from 'react';
import { DocumentArrowDownIcon, EyeIcon, PlusIcon, BanknotesIcon, ChevronDownIcon, ChevronUpIcon, EllipsisVerticalIcon } from '@heroicons/react/20/solid';
import { generateInvoicePDF, generateInvoiceNumber } from '../utils/invoiceUtils';

function Invoices() {
  const [invoices, setInvoices] = useState([]);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [packages, setPackages] = useState([]);
  const [filteredPackages, setFilteredPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [packageSearchQuery, setPackageSearchQuery] = useState('');
  const [checkNumber, setCheckNumber] = useState('');
  const [paymentDate, setPaymentDate] = useState(new Date().toISOString().split('T')[0]);
  const [filterStatus, setFilterStatus] = useState('all'); // 'all', 'paid', 'unpaid', 'overdue'
  const [sortField, setSortField] = useState('invoice_number');
  const [sortDirection, setSortDirection] = useState('asc');
  const [referenceNumber, setReferenceNumber] = useState('');
    const [paymentType, setPaymentType] = useState('Check');
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editReferenceNumber, setEditReferenceNumber] = useState('');
    const [editPaymentType, setEditPaymentType] = useState('Check');
    const [editNotes, setEditNotes] = useState('');
    const [editStatus, setEditStatus] = useState('unpaid');
const [editPaymentDate, setEditPaymentDate] = useState(new Date().toISOString().split('T')[0]);
const [isPdfLoading, setIsPdfLoading] = useState(false);
const [pdfLoadError, setPdfLoadError] = useState(false);
const [currentPdfPath, setCurrentPdfPath] = useState(null);
const [signedUrl, setSignedUrl] = useState(null);
const [expandedRows, setExpandedRows] = useState({});
const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
const [emailRecipient, setEmailRecipient] = useState('');
const [selectedInvoiceForEmail, setSelectedInvoiceForEmail] = useState(null);
const [isEmailLoading, setIsEmailLoading] = useState(false); // Loading state for email sending
const [emailSuccess, setEmailSuccess] = useState(false); // Success state for email sending
const [emailRecipients, setEmailRecipients] = useState([]); // Array of email addresses
const [currentEmailInput, setCurrentEmailInput] = useState(''); // Current email being typed
const [emailLogs, setEmailLogs] = useState([]); // Store email logs for all invoices
const [isEmailHistoryModalOpen, setIsEmailHistoryModalOpen] = useState(false); // Control email history modal
const [selectedEmailHistory, setSelectedEmailHistory] = useState([]); // Store email logs for the selected invoice
// Add these state variables after the existing useState declarations (around line 30)
const [isExportModalOpen, setIsExportModalOpen] = useState(false);
const [selectedCustomerForExport, setSelectedCustomerForExport] = useState('all');
const [fileType, setFileType] = useState('CSV');
const [isGeneratingExport, setIsGeneratingExport] = useState(false);

// Add these functions after the existing handler functions (around line 800)

// Get unique customers for dropdown
const getUniqueCustomers = () => {
  const uniqueCustomers = invoices.reduce((acc, invoice) => {
    // Check if customer_id exists and is not null/undefined
    if (invoice.customer_id && invoice.customer_nickname && 
        !acc.find(c => c.customer_id === invoice.customer_id)) {
      acc.push({
        customer_id: invoice.customer_id,
        customer_nickname: invoice.customer_nickname || `Customer ${invoice.customer_id}`
      });
    }
    return acc;
  }, []);
  
  console.log('Unique customers found:', uniqueCustomers);
  console.log('Sample invoices for debugging:', invoices.slice(0, 2).map(inv => ({
    customer_id: inv.customer_id,
    customer_nickname: inv.customer_nickname,
    invoice_number: inv.invoice_number
  })));
  
  return uniqueCustomers.sort((a, b) => a.customer_nickname.localeCompare(b.customer_nickname));
};
// Open export modal
const openExportModal = () => {
  setIsExportModalOpen(true);
  setSelectedCustomerForExport('all');
  setFileType('CSV');
};

// Close export modal
const closeExportModal = () => {
  setIsExportModalOpen(false);
  setSelectedCustomerForExport('all');
  setFileType('CSV');
  setIsGeneratingExport(false);
};

// Generate and download CSV
const handleGenerateExport = async () => {
  setIsGeneratingExport(true);
  
  try {
    // Filter invoices by selected customer
    
    // NEW CODE - REPLACE WITH THIS:
let exportInvoices = invoices;
if (selectedCustomerForExport !== 'all') {
  // Handle both string and number customer IDs
  const selectedCustomerId = selectedCustomerForExport;
  exportInvoices = invoices.filter(inv => {
    // Compare both as strings and numbers to handle different data types
    return inv.customer_id == selectedCustomerId || 
           String(inv.customer_id) === String(selectedCustomerId);
  });
  
  console.log('Selected customer ID:', selectedCustomerId, 'Type:', typeof selectedCustomerId);
  console.log('All invoice customer IDs:', invoices.map(inv => ({ id: inv.customer_id, type: typeof inv.customer_id, nickname: inv.customer_nickname })));
  console.log('Filtered invoices:', exportInvoices.length);
  console.log('Filtered invoice numbers:', exportInvoices.map(inv => inv.invoice_number));
}
    
    if (exportInvoices.length === 0) {
      toast.error('No invoices found for the selected criteria.');
      setIsGeneratingExport(false);
      return;
    }
    
    // Generate CSV content
    const csvHeaders = [
      'Invoice Number',
      'Customer',
      'Package Number',
      'PO Number',
      'Total Quantity',
      'Total Amount',
      'Status',
      'Created Date',
      'Due Date',
      'Payment Date',
      'Payment Type',
      'Reference Number',
      'Notes'
    ];
    
    const csvRows = exportInvoices.map(invoice => [
      invoice.invoice_number,
      invoice.customer_nickname,
      invoice.package_number,
      invoice.po_number || '',
      invoice.total_quantity,
      invoice.total_amount.toFixed(2),
      invoice.status,
      new Date(invoice.created_at).toLocaleDateString(),
      new Date(invoice.net_due_date).toLocaleDateString(),
      invoice.payment_date ? new Date(invoice.payment_date).toLocaleDateString() : '',
      invoice.payment_type || '',
      invoice.reference_number || '',
      invoice.notes || ''
    ]);
    
    // Convert to CSV string
    const csvContent = [
      csvHeaders.join(','),
      ...csvRows.map(row => 
        row.map(field => 
          // Escape commas and quotes in fields
          typeof field === 'string' && (field.includes(',') || field.includes('"')) 
            ? `"${field.replace(/"/g, '""')}"` 
            : field
        ).join(',')
      )
    ].join('\n');
    
    // Create and download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    
    // Generate filename
    const customerName = selectedCustomerForExport === 'all' 
      ? 'All_Customers' 
      : invoices.find(inv => inv.customer_id === selectedCustomerForExport)?.customer_nickname || 'Customer';
    const timestamp = new Date().toISOString().split('T')[0];
    link.setAttribute('download', `Invoices_${customerName}_${timestamp}.csv`);
    
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    toast.success(`CSV exported successfully! ${exportInvoices.length} invoices included.`);
    closeExportModal();
    
  } catch (error) {
    console.error('Error generating export:', error);
    toast.error(`Failed to generate export: ${error.message}`);
  } finally {
    setIsGeneratingExport(false);
  }
};


  document.title = 'Invoices';

  useEffect(() => {
    const fetchData = async () => {
        setLoading(true);
        try {
          // Fetch all invoices
          const { data: invoicesData, error: invoicesError } = await supabase
            .from('invoices')
            .select(`
              invoice_number, package_number, customer_id, total_quantity, total_amount, 
              status, pdf_path, reference_number, payment_date, created_at, net_due_date, 
              payment_type, notes,
              customers!customer_id(nickname, billing_contact_email, shipping_contact_email)
            `)
            .order('created_at', { ascending: false });
          if (invoicesError) throw new Error(`Invoices fetch error: ${invoicesError.message}`);
      
          // Fetch all deliveries
          const { data: deliveriesData, error: deliveriesError } = await supabase
            .from('deliveries')
            .select(`
              package_number, quantity, invoice_number, po_number, po_line_number, part_number,
              job_id, kanban_job_id, ship_date, tracking_number, ship_by,
              jobs!left(unit_price, customer_id, customers!left(nickname, billing_contact_email, shipping_contact_email)),
              kanban_jobs!left(unit_price, description, customers!left(nickname, billing_contact_email, shipping_contact_email)),
              parts!part_number(description)
            `);
          if (deliveriesError) throw new Error(`Deliveries fetch error: ${deliveriesError.message}`);
      
          // Fetch email logs
          const { data: emailLogsData, error: emailLogsError } = await supabase
            .from('emails')
            .select('id, invoice_number, recipients, sent_at, status, error_message')
            .order('sent_at', { ascending: false });
          if (emailLogsError) throw new Error(`Email logs fetch error: ${emailLogsError.message}`);
          setEmailLogs(emailLogsData || []);
      
          // Format invoices and attach corresponding deliveries using package_number
          const formattedInvoices = invoicesData.map(invoice => {
            // Find deliveries associated with this invoice using package_number
            const associatedDeliveries = deliveriesData
              .filter(delivery => delivery.package_number === invoice.package_number)
              .map(delivery => ({
                ...delivery,
                description: delivery.parts?.description || delivery.kanban_jobs?.description || 'N/A',
                jobs: delivery.jobs || {},
                kanban_jobs: delivery.kanban_jobs || {},
              }));
      
            // Find email logs for this invoice
            const invoiceEmailLogs = emailLogsData.filter(log => log.invoice_number === invoice.invoice_number);
      
            return {
              ...invoice,
              customer_nickname: invoice.customers?.nickname || '-',
              billing_contact_email: invoice.customers?.billing_contact_email || '', // Add billing email
              shipping_contact_email: invoice.customers?.shipping_contact_email || '', // Add shipping/contact email
              po_number: associatedDeliveries[0]?.po_number || 'N/A',
              deliveries: associatedDeliveries || [], // Ensure deliveries is always an array
              email_logs: invoiceEmailLogs, // Attach email logs to the invoice
            };
          });
          setInvoices(formattedInvoices);
          setFilteredInvoices(formattedInvoices);
      
          // Group deliveries by package_number and filter out invoiced packages for the create invoice modal
          const groupedPackages = deliveriesData.reduce((acc, delivery) => {
            const packageNumber = delivery.package_number;
            if (!acc[packageNumber]) {
              acc[packageNumber] = {
                package_number: packageNumber,
                po_number: delivery.po_number,
                deliveries: [],
                total_quantity: 0,
                total_amount: 0,
                customer: null,
                customer_nickname: '',
                has_invoice: false,
              };
            }
            if (delivery.jobs) {
              delivery.jobs.customers = delivery.jobs.customers || {};
            } else if (delivery.kanban_jobs) {
              delivery.kanban_jobs.customers = delivery.kanban_jobs.customers || {};
            }
      
            delivery.description = delivery.parts?.description || delivery.kanban_jobs?.description || 'N/A';
            acc[packageNumber].deliveries.push(delivery);
            acc[packageNumber].total_quantity += delivery.quantity;
      
            const unitPrice = delivery.jobs?.unit_price || delivery.kanban_jobs?.unit_price || 0;
            acc[packageNumber].total_amount += delivery.quantity * unitPrice;
      
            if (!acc[packageNumber].customer) {
              acc[packageNumber].customer = delivery.jobs?.customers || delivery.kanban_jobs?.customers || {};
              acc[packageNumber].customer_nickname = acc[packageNumber].customer.nickname || '-';
            }
      
            if (delivery.invoice_number) {
              acc[packageNumber].has_invoice = true;
            }
      
            return acc;
          }, {});
      
          const packageArray = Object.values(groupedPackages).filter(pkg => !pkg.has_invoice);
          setPackages(packageArray);
          setFilteredPackages(packageArray);
        } catch (err) {
          console.error('Error fetching data:', err.message);
          toast.error(`Failed to fetch data: ${err.message}`);
          setInvoices([]);
          setPackages([]);
          setFilteredInvoices([]);
          setFilteredPackages([]);
          setEmailLogs([]);
        } finally {
          setLoading(false);
        }
      };
  
    fetchData();
  }, []);


  const fetchData = async () => {
    setLoading(true);
    try {
      // Fetch all invoices
      const { data: invoicesData, error: invoicesError } = await supabase
        .from('invoices')
        .select(`
          invoice_number, package_number, customer_id, total_quantity, total_amount, 
          status, pdf_path, reference_number, payment_date, created_at, net_due_date, 
          payment_type, notes,
          customers!customer_id(nickname, billing_contact_email, shipping_contact_email)
        `)
        .order('created_at', { ascending: false });
      if (invoicesError) throw new Error(`Invoices fetch error: ${invoicesError.message}`);
  
      // Fetch all deliveries
      const { data: deliveriesData, error: deliveriesError } = await supabase
        .from('deliveries')
        .select(`
          package_number, quantity, invoice_number, po_number, po_line_number, part_number,
          job_id, kanban_job_id, ship_date, tracking_number, ship_by,
          jobs!left(unit_price, customer_id, customers!left(nickname, billing_contact_email, shipping_contact_email)),
          kanban_jobs!left(unit_price, description, customers!left(nickname, billing_contact_email, shipping_contact_email)),
          parts!part_number(description)
        `);
      if (deliveriesError) throw new Error(`Deliveries fetch error: ${deliveriesError.message}`);
  
      // Fetch email logs
      const { data: emailLogsData, error: emailLogsError } = await supabase
        .from('emails')
        .select('id, invoice_number, recipients, sent_at, status, error_message')
        .order('sent_at', { ascending: false });
      if (emailLogsError) throw new Error(`Email logs fetch error: ${emailLogsError.message}`);
      setEmailLogs(emailLogsData || []);
  
      // Format invoices and attach corresponding deliveries using package_number
      const formattedInvoices = invoicesData.map(invoice => {
        // Find deliveries associated with this invoice using package_number
        const associatedDeliveries = deliveriesData
          .filter(delivery => delivery.package_number === invoice.package_number)
          .map(delivery => ({
            ...delivery,
            description: delivery.parts?.description || delivery.kanban_jobs?.description || 'N/A',
            jobs: delivery.jobs || {},
            kanban_jobs: delivery.kanban_jobs || {},
          }));
  
        // Find email logs for this invoice
        const invoiceEmailLogs = emailLogsData.filter(log => log.invoice_number === invoice.invoice_number);
  
        return {
          ...invoice,
          customer_nickname: invoice.customers?.nickname || '-',
          billing_contact_email: invoice.customers?.billing_contact_email || '', // Add billing email
          shipping_contact_email: invoice.customers?.shipping_contact_email || '', // Add shipping/contact email
          po_number: associatedDeliveries[0]?.po_number || 'N/A',
          deliveries: associatedDeliveries || [], // Ensure deliveries is always an array
          email_logs: invoiceEmailLogs, // Attach email logs to the invoice
        };
      });
      setInvoices(formattedInvoices);
      setFilteredInvoices(formattedInvoices);
  
      // Group deliveries by package_number and filter out invoiced packages for the create invoice modal
      const groupedPackages = deliveriesData.reduce((acc, delivery) => {
        const packageNumber = delivery.package_number;
        if (!acc[packageNumber]) {
          acc[packageNumber] = {
            package_number: packageNumber,
            po_number: delivery.po_number,
            deliveries: [],
            total_quantity: 0,
            total_amount: 0,
            customer: null,
            customer_nickname: '',
            has_invoice: false,
          };
        }
        if (delivery.jobs) {
          delivery.jobs.customers = delivery.jobs.customers || {};
        } else if (delivery.kanban_jobs) {
          delivery.kanban_jobs.customers = delivery.kanban_jobs.customers || {};
        }
  
        delivery.description = delivery.parts?.description || delivery.kanban_jobs?.description || 'N/A';
        acc[packageNumber].deliveries.push(delivery);
        acc[packageNumber].total_quantity += delivery.quantity;
  
        const unitPrice = delivery.jobs?.unit_price || delivery.kanban_jobs?.unit_price || 0;
        acc[packageNumber].total_amount += delivery.quantity * unitPrice;
  
        if (!acc[packageNumber].customer) {
          acc[packageNumber].customer = delivery.jobs?.customers || delivery.kanban_jobs?.customers || {};
          acc[packageNumber].customer_nickname = acc[packageNumber].customer.nickname || '-';
        }
  
        if (delivery.invoice_number) {
          acc[packageNumber].has_invoice = true;
        }
  
        return acc;
      }, {});
  
      const packageArray = Object.values(groupedPackages).filter(pkg => !pkg.has_invoice);
      setPackages(packageArray);
      setFilteredPackages(packageArray);
    } catch (err) {
      console.error('Error fetching data:', err.message);
      toast.error(`Failed to fetch data: ${err.message}`);
      setInvoices([]);
      setPackages([]);
      setFilteredInvoices([]);
      setFilteredPackages([]);
      setEmailLogs([]);
    } finally {
      setLoading(false);
    }
  };

  // Filter and sort invoices
  useEffect(() => {
    let filtered = [...invoices];

    // Apply status filter
    if (filterStatus !== 'all') {
      if (filterStatus === 'paid') {
        filtered = filtered.filter(inv => inv.status === 'paid');
      } else if (filterStatus === 'unpaid') {
        filtered = filtered.filter(inv => inv.status === 'unpaid');
      } else if (filterStatus === 'overdue') {
        const today = new Date();
        filtered = filtered.filter(inv => inv.status === 'unpaid' && new Date(inv.net_due_date) < today);
      }
    }

    // Apply sorting
    filtered.sort((a, b) => {
      let aValue = a[sortField] || '';
      let bValue = b[sortField] || '';
      if (sortField === 'total_quantity' || sortField === 'total_amount') {
        aValue = aValue || 0;
        bValue = bValue || 0;
        return sortDirection === 'asc' ? aValue - bValue : bValue - aValue;
      }
      if (sortField === 'created_at' || sortField === 'net_due_date') {
        aValue = new Date(aValue).getTime();
        bValue = new Date(bValue).getTime();
        return sortDirection === 'asc' ? aValue - bValue : bValue - aValue;
      }
      aValue = String(aValue).toLowerCase();
      bValue = String(bValue).toLowerCase();
      return sortDirection === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
    });

    setFilteredInvoices(filtered);
  }, [filterStatus, sortField, sortDirection, invoices]);

  // Filter packages in the Create Invoice modal
  useEffect(() => {
    let filtered = [...packages];
    if (packageSearchQuery) {
      filtered = filtered.filter(pkg =>
        pkg.package_number.toLowerCase().includes(packageSearchQuery.toLowerCase())
      );
    }
    setFilteredPackages(filtered);
  }, [packageSearchQuery, packages]);

  // Calculate summary metrics
  const accountsReceivable = invoices
    .filter(inv => inv.status === 'unpaid')
    .reduce((sum, inv) => sum + inv.total_amount, 0);
  const cashReceived = invoices
    .filter(inv => inv.status === 'paid')
    .reduce((sum, inv) => sum + inv.total_amount, 0);
  const totalInvoiced = invoices.reduce((sum, inv) => sum + inv.total_amount, 0);
  const overdueAmount = invoices
    .filter(inv => inv.status === 'unpaid' && new Date(inv.net_due_date) < new Date())
    .reduce((sum, inv) => sum + inv.total_amount, 0);

  


  const handleCreateInvoice = async () => {
    if (!selectedPackage) {
      toast.error('Please select a package to invoice.');
      return;
    }
  
    try {
      // Generate a unique invoice number
      const invoiceNumber = await generateInvoiceNumber();
  
      // Create the invoice record
      const createdAt = new Date();
      const customer = selectedPackage.customer || {};
      const netTerms = customer.net_terms || 15;
      const netDueDate = new Date(createdAt);
      netDueDate.setDate(netDueDate.getDate() + netTerms);
  
      const { data: invoiceData, error: invoiceError } = await supabase
        .from('invoices')
        .insert({
          invoice_number: invoiceNumber,
          package_number: selectedPackage.package_number,
          customer_id: selectedPackage.deliveries[0].jobs?.customer_id || selectedPackage.deliveries[0].kanban_jobs?.customers?.id || null,
          total_quantity: selectedPackage.total_quantity,
          total_amount: selectedPackage.total_amount,
          status: 'unpaid',
          created_at: createdAt.toISOString(),
          net_due_date: netDueDate.toISOString(),
          notes: null, // Initially null, can be added during edit
        })
        .select()
        .single();
      if (invoiceError) throw new Error(`Failed to create invoice: ${invoiceError.message}`);
  
      // Update all deliveries in the package with the invoice number
      const { error: updateError } = await supabase
        .from('deliveries')
        .update({ invoice_number: invoiceNumber })
        .eq('package_number', selectedPackage.package_number);
      if (updateError) throw new Error(`Failed to update deliveries: ${updateError.message}`);

      // Fetch part_number_master for each delivery
    const partNumbers = selectedPackage.deliveries.map(delivery => delivery.part_number);
    const { data: partsData, error: partsError } = await supabase
      .from('parts')
      .select('part_number, part_number_master')
      .in('part_number', partNumbers);
    if (partsError) throw new Error(`Failed to fetch parts data: ${partsError.message}`);

    // Create a mapping of part_number to part_number_master
    const partNumberMap = partsData.reduce((acc, part) => {
      acc[part.part_number] = part.part_number_master || part.part_number; // Fallback to part_number if part_number_master is null
      return acc;
    }, {});
    
      // Fetch complete customer data for PDF generation
const { data: customerData, error: customerError } = await supabase
.from('customers')
.select('*')
.eq('id', selectedPackage.deliveries[0].jobs?.customer_id || selectedPackage.deliveries[0].kanban_jobs?.customers?.id)
.single();
if (customerError) throw new Error(`Failed to fetch customer data: ${customerError.message}`);

// Prepare the package for PDF generation
const invoicePackage = {
package_number: selectedPackage.package_number,
po_number: selectedPackage.po_number,
deliveries: selectedPackage.deliveries.map(delivery => ({
  ...delivery,
  part_number: partNumberMap[delivery.part_number] || delivery.part_number,
})),
total_quantity: selectedPackage.total_quantity,
total_amount: selectedPackage.total_amount,
customer: customerData || {}, // Use complete customer data
net_terms: netTerms,
notes: null,
};
      
  
      // Generate and upload the PDF using the utility function
      const pdfBlob = await generateInvoicePDF(invoicePackage, invoiceNumber, createdAt, netDueDate);
      const pdfFilePath = `invoices/${invoiceNumber}.pdf`;
      const { error: uploadError } = await supabase.storage
        .from('invoices')
        .upload(pdfFilePath, pdfBlob, { contentType: 'application/pdf' });
      if (uploadError) throw new Error(`Failed to upload invoice PDF: ${uploadError.message}`);
  
      // Update the invoice with the PDF path
      const { error: updateInvoiceError } = await supabase
        .from('invoices')
        .update({ pdf_path: pdfFilePath })
        .eq('invoice_number', invoiceNumber);
      if (updateInvoiceError) throw new Error(`Failed to update invoice with PDF path: ${updateInvoiceError.message}`);
  
      // Update the local state
      const newInvoice = {
        invoice_number: invoiceNumber,
        package_number: selectedPackage.package_number,
        customer_id: selectedPackage.deliveries[0].jobs?.customer_id || selectedPackage.deliveries[0].kanban_jobs?.customers?.id || null,
        total_quantity: selectedPackage.total_quantity,
        total_amount: selectedPackage.total_amount,
        status: 'unpaid',
        pdf_path: pdfFilePath,
        reference_number: null,
        payment_date: null,
        payment_type: null,
        notes: null,
        created_at: createdAt.toISOString(),
        net_due_date: netDueDate.toISOString(),
        customer_nickname: selectedPackage.customer_nickname,
        net_terms: netTerms,
      };
  
      setInvoices([newInvoice, ...invoices]);
      setFilteredInvoices([newInvoice, ...filteredInvoices]);
      setPackages(packages.filter(pkg => pkg.package_number !== selectedPackage.package_number));
      setFilteredPackages(filteredPackages.filter(pkg => pkg.package_number !== selectedPackage.package_number));
      setSelectedPackage(null);
      setIsCreateModalOpen(false);
      fetchData(); // Refetch data to ensure consistency
      toast.success(`Invoice ${invoiceNumber} created successfully!`);
    } catch (err) {
      console.error('Error creating invoice:', err);
      toast.error(`Failed to create invoice: ${err.message}`);
    }
  };

const handleRecordPayment = async () => {
    if (!selectedInvoice || !referenceNumber || !paymentDate || !paymentType) {
      toast.error('Please provide a reference number, payment date, and payment type.');
      return;
    }
  
    try {
      const { error } = await supabase
        .from('invoices')
        .update({
          status: 'paid',
          reference_number: referenceNumber,
          payment_date: paymentDate,
          payment_type: paymentType,
        })
        .eq('invoice_number', selectedInvoice.invoice_number);
      if (error) throw new Error(`Failed to record payment: ${error.message}`);
  
      setInvoices(invoices.map(inv =>
        inv.invoice_number === selectedInvoice.invoice_number
          ? { ...inv, status: 'paid', reference_number: referenceNumber, payment_date: paymentDate, payment_type: paymentType }
          : inv
      ));
      setFilteredInvoices(filteredInvoices.map(inv =>
        inv.invoice_number === selectedInvoice.invoice_number
          ? { ...inv, status: 'paid', reference_number: referenceNumber, payment_date: paymentDate, payment_type: paymentType }
          : inv
      ));
  
      setIsPaymentModalOpen(false);
      setSelectedInvoice(null);
      setReferenceNumber('');
      setPaymentType('Check');
      setPaymentDate(new Date().toISOString().split('T')[0]);
      toast.success('Payment recorded successfully!');
    } catch (err) {
      console.error('Error recording payment:', err);
      toast.error(`Failed to record payment: ${err.message}`);
    }
  };

  const openCreateModal = () => {
    setIsCreateModalOpen(true);
    setSelectedPackage(null);
    setPackageSearchQuery('');
  };

  const closeCreateModal = () => {
    setIsCreateModalOpen(false);
    setSelectedPackage(null);
    setPackageSearchQuery('');
  };

  const openPaymentModal = (invoice) => {
    setSelectedInvoice(invoice);
    setIsPaymentModalOpen(true);
  };

  const closePaymentModal = () => {
    setIsPaymentModalOpen(false);
    setSelectedInvoice(null);
    setReferenceNumber('');
    setPaymentType('Check');
    setPaymentDate(new Date().toISOString().split('T')[0]);
  };

  const openPdfModal = async (pdfPath) => {
    try {
      const { data, error } = await supabase.storage
        .from('invoices')
        .createSignedUrl(pdfPath, 300); // 300 seconds validity
      if (error) {
        console.error('Failed to generate signed URL:', error);
        throw new Error(`Failed to generate signed URL: ${error.message}`);
      }
  
      // Detect if running on Windows using navigator.platform
      const isWindows = navigator.platform.indexOf('Win') > -1;
  
      if (isWindows) {
        // On Windows: Open the PDF in a new tab...
        window.open(data.signedUrl, '_blank');
        // ...and refresh the original tab to clear any stuck modal state.
        window.location.reload();
      } else {
        // On non-Windows: Display the PDF in a modal.
        setSignedUrl(data.signedUrl);
        setCurrentPdfPath(pdfPath);
        setIsPdfModalOpen(true);
      }
    } catch (err) {
      console.error('Error opening PDF:', err);
      toast.error(`Failed to open PDF: ${err.message}`);
    }
  };
  

  const closePdfModal = () => {
    setIsPdfModalOpen(false);
    setSignedUrl(null);
    setPdfLoadError(false);
    setCurrentPdfPath(null);
  };

  const handleSort = (field) => {
    const newDirection = sortField === field && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortDirection(newDirection);
  };

  const openEditModal = (invoice) => {
    setSelectedInvoice(invoice);
    setEditReferenceNumber(invoice.reference_number || '');
    setEditPaymentType(invoice.payment_type || 'Check');
    setEditNotes(invoice.notes || '');
    setEditStatus(invoice.status || 'unpaid');
    setEditPaymentDate(invoice.payment_date ? new Date(invoice.payment_date).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]);
    setIsEditModalOpen(true);
  };
  
  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedInvoice(null);
    setEditReferenceNumber('');
    setEditPaymentType('Check');
    setEditNotes('');
    setEditStatus('unpaid');
    setEditPaymentDate(new Date().toISOString().split('T')[0]);
  };
  
  const handleEditInvoice = async () => {
    if (!selectedInvoice) {
      toast.error('No invoice selected to edit.');
      return;
    }
  
    // Validate payment date if status is "Paid"
    if (editStatus === 'paid' && !editPaymentDate) {
      toast.error('Please provide a payment date for a paid invoice.');
      return;
    }
  
    try {
      // Check if notes have changed
      const notesChanged = selectedInvoice.notes !== editNotes;
  
      // Update the invoice record
      const { error: updateError } = await supabase
        .from('invoices')
        .update({
          reference_number: editStatus === 'paid' ? editReferenceNumber || null : null,
          payment_type: editStatus === 'paid' ? editPaymentType || null : null,
          notes: editNotes || null,
          status: editStatus,
          payment_date: editStatus === 'paid' ? editPaymentDate : null,
        })
        .eq('invoice_number', selectedInvoice.invoice_number);
      if (updateError) throw new Error(`Failed to update invoice: ${updateError.message}`);
  
      // If notes have changed, regenerate and replace the PDF
      if (notesChanged) {
        const { data: deliveriesData, error: deliveriesError } = await supabase
          .from('deliveries')
          .select(`
            package_number, quantity, invoice_number, po_number, po_line_number, part_number,
            job_id, kanban_job_id, ship_date, tracking_number, ship_by,
            jobs!left(unit_price, customer_id, customers!left(*)),
            kanban_jobs!left(unit_price, description, customers!left(*)),
            parts!part_number(description, part_number_master)
          `)
          .eq('package_number', selectedInvoice.package_number);
        if (deliveriesError) throw new Error(`Failed to fetch deliveries: ${deliveriesError.message}`);
  
        const deliveryPackage = deliveriesData.reduce((acc, delivery) => {
          if (!acc.package_number) {
            acc.package_number = delivery.package_number;
            acc.po_number = delivery.po_number;
            acc.deliveries = [];
            acc.total_quantity = 0;
            acc.total_amount = 0;
            acc.customer = delivery.jobs?.customers || delivery.kanban_jobs?.customers || {};
          }
          // Add description and replace part_number with part_number_master
          delivery.description = delivery.parts?.description || delivery.kanban_jobs?.description || 'N/A';
          delivery.part_number = delivery.parts?.part_number_master || delivery.part_number; // Replace part_number with part_number_master
          acc.deliveries.push(delivery);
          acc.total_quantity += delivery.quantity;
          const unitPrice = delivery.jobs?.unit_price || delivery.kanban_jobs?.unit_price || 0;
          acc.total_amount += delivery.quantity * unitPrice;
          return acc;
        }, {});
  
        deliveryPackage.notes = editNotes || null;
  
        const pdfBlob = await generateInvoicePDF(deliveryPackage, selectedInvoice.invoice_number, selectedInvoice.created_at, selectedInvoice.net_due_date);
  
        const pdfFilePath = `invoices/${selectedInvoice.invoice_number}.pdf`;
        const { error: uploadError } = await supabase.storage
          .from('invoices')
          .update(pdfFilePath, pdfBlob, { contentType: 'application/pdf' });
        if (uploadError) throw new Error(`Failed to update invoice PDF: ${uploadError.message}`);
      }
  
      // Update the local state
      setInvoices(invoices.map(inv =>
        inv.invoice_number === selectedInvoice.invoice_number
          ? { 
              ...inv, 
              reference_number: editStatus === 'paid' ? editReferenceNumber || null : null,
              payment_type: editStatus === 'paid' ? editPaymentType || null : null,
              notes: editNotes,
              status: editStatus,
              payment_date: editStatus === 'paid' ? editPaymentDate : null,
            }
          : inv
      ));
      setFilteredInvoices(filteredInvoices.map(inv =>
        inv.invoice_number === selectedInvoice.invoice_number
          ? { 
              ...inv, 
              reference_number: editStatus === 'paid' ? editReferenceNumber || null : null,
              payment_type: editStatus === 'paid' ? editPaymentType || null : null,
              notes: editNotes,
              status: editStatus,
              payment_date: editStatus === 'paid' ? editPaymentDate : null,
            }
          : inv
      ));
  
      closeEditModal();
      fetchData(); // Refetch data to ensure consistency
      toast.success('Invoice updated successfully!');
    } catch (err) {
      console.error('Error updating invoice:', err);
      toast.error(`Failed to update invoice: ${err.message}`);
    }
  };

  const handleDeleteInvoice = async () => {
    if (!selectedInvoice) {
      toast.error('No invoice selected to delete.');
      return;
    }
  
    try {
      // Delete the PDF file from storage
      const pdfFilePath = selectedInvoice.pdf_path;
      if (pdfFilePath) {
        const { error: storageError } = await supabase.storage
          .from('invoices')
          .remove([pdfFilePath]);
        if (storageError) throw new Error(`Failed to delete invoice PDF: ${storageError.message}`);
      }
  
      // Clear the invoice_number from associated deliveries
      const { error: deliveryError } = await supabase
        .from('deliveries')
        .update({ invoice_number: null })
        .eq('invoice_number', selectedInvoice.invoice_number);
      if (deliveryError) throw new Error(`Failed to clear invoice from deliveries: ${deliveryError.message}`);
  
      // Delete the invoice record
      const { error: deleteError } = await supabase
        .from('invoices')
        .delete()
        .eq('invoice_number', selectedInvoice.invoice_number);
      if (deleteError) throw new Error(`Failed to delete invoice: ${deleteError.message}`);
  
      // Update local state
      setInvoices(invoices.filter(inv => inv.invoice_number !== selectedInvoice.invoice_number));
      setFilteredInvoices(filteredInvoices.filter(inv => inv.invoice_number !== selectedInvoice.invoice_number));
  
      // Refetch packages to include the now-uninvoiced package
      const { data: deliveriesData, error: deliveriesError } = await supabase
        .from('deliveries')
        .select(`
          package_number, quantity, invoice_number, po_number, po_line_number, part_number,
          job_id, kanban_job_id,
          jobs!left(unit_price, customer_id, customers!left(*)),
          kanban_jobs!left(unit_price, description, customers!left(*)),
          parts!part_number(description)
        `);
      if (deliveriesError) throw new Error(`Deliveries fetch error: ${deliveriesError.message}`);
  
      const groupedPackages = deliveriesData.reduce((acc, delivery) => {
        const packageNumber = delivery.package_number;
        if (!acc[packageNumber]) {
          acc[packageNumber] = {
            package_number: packageNumber,
            po_number: delivery.po_number,
            deliveries: [],
            total_quantity: 0,
            total_amount: 0,
            customer: null,
            customer_nickname: '',
            has_invoice: false,
          };
        }
        if (delivery.jobs) {
          delivery.jobs.customers = delivery.jobs.customers || {};
        } else if (delivery.kanban_jobs) {
          delivery.kanban_jobs.customers = delivery.kanban_jobs.customers || {};
        }
        // Add description to the delivery object, prioritizing parts table
        delivery.description = delivery.parts?.description || delivery.kanban_jobs?.description || 'N/A';
        acc[packageNumber].deliveries.push(delivery);
        acc[packageNumber].total_quantity += delivery.quantity;
  
        const unitPrice = delivery.jobs?.unit_price || delivery.kanban_jobs?.unit_price || 0;
        acc[packageNumber].total_amount += delivery.quantity * unitPrice;
  
        if (!acc[packageNumber].customer) {
          acc[packageNumber].customer = delivery.jobs?.customers || delivery.kanban_jobs?.customers || {};
          acc[packageNumber].customer_nickname = acc[packageNumber].customer.nickname || '-';
        }
  
        if (delivery.invoice_number) {
          acc[packageNumber].has_invoice = true;
        }
  
        return acc;
      }, {});
  
      const packageArray = Object.values(groupedPackages).filter(pkg => !pkg.has_invoice);
      setPackages(packageArray);
      setFilteredPackages(packageArray);
  
      closeEditModal();
      toast.success(`Invoice ${selectedInvoice.invoice_number} deleted successfully!`);
    } catch (err) {
      console.error('Error deleting invoice:', err);
      toast.error(`Failed to delete invoice: ${err.message}`);
    }
  };


const toggleRow = (invoiceNumber) => {
    setExpandedRows((prev) => ({
      ...prev,
      [invoiceNumber]: !prev[invoiceNumber],
    }));
  };

  // Add this compression function at the top of your component or in a utils file
// Add this compression function with timeout at the top of your component or in a utils file
const compressBase64 = async (base64String, timeoutMs = 5000) => {
  // Check if compression is supported
  if (typeof CompressionStream === 'undefined') {
    console.warn('CompressionStream not supported, sending uncompressed');
    return base64String;
  }

  try {
    const compressionPromise = new Promise(async (resolve, reject) => {
      try {
        // Convert base64 to bytes
        const bytes = Uint8Array.from(atob(base64String), c => c.charCodeAt(0));
        
        // Create compression stream
        const compressStream = new CompressionStream('gzip');
        const writer = compressStream.writable.getWriter();
        const reader = compressStream.readable.getReader();
        
        // Write original data
        await writer.write(bytes);
        await writer.close();
        
        // Read compressed data
        const chunks = [];
        let result = await reader.read();
        while (!result.done) {
          chunks.push(result.value);
          result = await reader.read();
        }
        
        // Combine chunks
        const totalLength = chunks.reduce((sum, chunk) => sum + chunk.length, 0);
        const combined = new Uint8Array(totalLength);
        let offset = 0;
        for (const chunk of chunks) {
          combined.set(chunk, offset);
          offset += chunk.length;
        }
        
        // Convert back to base64
        resolve(btoa(String.fromCharCode(...combined)));
      } catch (error) {
        reject(error);
      }
    });

    // Race between compression and timeout
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => reject(new Error('Compression timeout')), timeoutMs);
    });

    return await Promise.race([compressionPromise, timeoutPromise]);
    
  } catch (error) {
    console.warn(`Compression failed (${error.message}), sending uncompressed`);
    return base64String; // Return original if compression fails or times out
  }
};

const handleSendEmail = async () => {
  if (!selectedInvoiceForEmail || emailRecipients.length === 0) {
    toast.error('Please select an invoice and enter at least one valid email address.');
    return;
  }

  setIsEmailLoading(true); // Start loading state
  setEmailSuccess(false); // Reset success state

  try {
    // Fetch the invoice PDF from Supabase Storage
    const { data: pdfData, error: pdfError } = await supabase.storage
      .from('invoices')
      .download(selectedInvoiceForEmail.pdf_path);
    if (pdfError) throw new Error(`Failed to download invoice PDF: ${pdfError.message}`);

    // Convert the PDF blob to a base64 string using FileReader
    const pdfBase64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result.split(',')[1];
        resolve(base64String);
      };
      reader.onerror = () => reject(new Error('Failed to read PDF blob as base64'));
      reader.readAsDataURL(pdfData);
    });

    // Compress the PDF base64 to reduce payload size
    console.log(`Original PDF size: ${pdfBase64.length} characters`);
    
    const startTime = Date.now();
    toast.info('Compressing PDF...', { autoClose: false, toastId: 'compressing' });
    
    const compressedPdf = await compressBase64(pdfBase64, 8000); // 8 second timeout
    
    const compressionTime = Date.now() - startTime;
    console.log(`Compressed PDF size: ${compressedPdf.length} characters`);
    console.log(`Compression took: ${compressionTime}ms`);
    console.log(`Compression ratio: ${(compressedPdf.length / pdfBase64.length * 100).toFixed(1)}%`);
    
    toast.dismiss('compressing');
    
    if (compressedPdf.length < pdfBase64.length) {
      toast.success(`PDF compressed by ${(100 - (compressedPdf.length / pdfBase64.length * 100)).toFixed(0)}%`);
    } else {
      toast.info('PDF sent uncompressed (compression not beneficial)');
    }

    // Call the Supabase Edge Function to send the email
    const response = await fetch('https://eiojxadvwbyjehiowyhd.supabase.co/functions/v1/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        invoiceNumber: selectedInvoiceForEmail.invoice_number,
        totalAmount: selectedInvoiceForEmail.total_amount,
        dueDate: selectedInvoiceForEmail.net_due_date,
        recipient: emailRecipients, // Send the array of recipients
        pdfBase64: compressedPdf, // Use compressed PDF instead of original
      }),
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.error || 'Failed to send email');
    }

    // Log the successful email send to the emails table
    const { data: newEmailLog, error: logError } = await supabase
      .from('emails')
      .insert({
        invoice_number: selectedInvoiceForEmail.invoice_number,
        recipients: emailRecipients,
        status: 'sent',
        error_message: null,
      })
      .select()
      .single();
    if (logError) {
      console.error('Error logging email send:', logError);
      toast.warn('Email sent, but failed to log the send event.');
    } else {
      // Add the new email log to the state
      setEmailLogs(prev => [newEmailLog, ...prev]);
      // Update the invoices state with the new email log
      setInvoices(prev =>
        prev.map(inv =>
          inv.invoice_number === selectedInvoiceForEmail.invoice_number
            ? { ...inv, email_logs: [newEmailLog, ...(inv.email_logs || [])] }
            : inv
        )
      );
      setFilteredInvoices(prev =>
        prev.map(inv =>
          inv.invoice_number === selectedInvoiceForEmail.invoice_number
            ? { ...inv, email_logs: [newEmailLog, ...(inv.email_logs || [])] }
            : inv
        )
      );
    }

    setIsEmailLoading(false); // Stop loading state
    setEmailSuccess(true); // Set success state

    // Show success message for 2 seconds, then close the modal
    setTimeout(() => {
      setIsEmailModalOpen(false);
      setEmailRecipients([]);
      setCurrentEmailInput('');
      setEmailSuccess(false);
      setSelectedInvoiceForEmail(null);
    }, 2000);

  } catch (err) {
    console.error('Error sending email:', err);

    // Log the failed email send to the emails table
    const { data: failedEmailLog, error: logError } = await supabase
      .from('emails')
      .insert({
        invoice_number: selectedInvoiceForEmail?.invoice_number || 'unknown',
        recipients: emailRecipients,
        status: 'failed',
        error_message: err.message,
      })
      .select()
      .single();
    if (logError) {
      console.error('Error logging email failure:', logError);
    } else {
      // Add the failed email log to the state
      setEmailLogs(prev => [failedEmailLog, ...prev]);
      setInvoices(prev =>
        prev.map(inv =>
          inv.invoice_number === selectedInvoiceForEmail?.invoice_number
            ? { ...inv, email_logs: [failedEmailLog, ...(inv.email_logs || [])] }
            : inv
        )
      );
      setFilteredInvoices(prev =>
        prev.map(inv =>
          inv.invoice_number === selectedInvoiceForEmail?.invoice_number
            ? { ...inv, email_logs: [failedEmailLog, ...(inv.email_logs || [])] }
            : inv
        )
      );
    }

    toast.error(`Failed to send email: ${err.message}`);
    setIsEmailLoading(false); // Stop loading state on error
  }
};

  if (loading) return <div className="text-center text-gray-500 py-10">Loading...</div>;

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto">
      <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Invoice Tracking</h1>
          <div className="flex space-x-3">
            <button
              onClick={openExportModal}
              className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition duration-200 shadow-sm"
            >
              <DocumentArrowDownIcon className="w-5 h-5 mr-2" />
              Export
            </button>
            <button
              onClick={openCreateModal}
              className="flex items-center px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition duration-200 shadow-sm"
            >
              <PlusIcon className="w-5 h-5 mr-2" />
              Create Invoice
            </button>
          </div>
        </div>

        {/* Summary Tiles */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div
           
            className="bg-white p-6 rounded-lg shadow-sm border border-gray-200"
          >
            <h3 className="text-sm font-medium text-gray-500">Accounts Receivable</h3>
            <p className="text-2xl font-semibold text-red-600">${accountsReceivable.toFixed(2)}</p>
          </div>
          <div
            
            className="bg-white p-6 rounded-lg shadow-sm border border-gray-200"
          >
            <h3 className="text-sm font-medium text-gray-500">Cash Received</h3>
            <p className="text-2xl font-semibold text-green-600">${cashReceived.toFixed(2)}</p>
          </div>
          <div
            
            className="bg-white p-6 rounded-lg shadow-sm border border-gray-200"
          >
            <h3 className="text-sm font-medium text-gray-500">Total Invoiced</h3>
            <p className="text-2xl font-semibold text-gray-900">${totalInvoiced.toFixed(2)}</p>
          </div>
          <div
            
            className="bg-white p-6 rounded-lg shadow-sm border border-gray-200"
          >
            <h3 className="text-sm font-medium text-gray-500">Overdue Invoices</h3>
            <p className="text-2xl font-semibold text-orange-600">${overdueAmount.toFixed(2)}</p>
          </div>
        </div>

        {/* Filters */}
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 mb-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-center">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Filter by Status</label>
              <select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                className="block w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
              >
                <option value="all">All</option>
                <option value="paid">Paid</option>
                <option value="unpaid">Unpaid</option>
                <option value="overdue">Overdue</option>
              </select>
            </div>
            <div className="flex justify-end">
              <button
                onClick={() => {
                  const sorted = [...filteredInvoices];
                  sorted.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                  setFilteredInvoices(sorted);
                }}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition duration-200 shadow-sm"
               
              >
                Sort by Latest
              </button>
            </div>
          </div>
        </div>

        {/* Invoices Table */}
        <div
         
          className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-x-auto"
        >
         <table className="min-w-full divide-y divide-gray-200">
  <thead className="bg-gray-50">
    <tr>
      <th
        className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider cursor-pointer"
        onClick={() => handleSort('invoice_number')}
      >
        Invoice # {sortField === 'invoice_number' && (sortDirection === 'asc' ? <ChevronUpIcon className="w-4 h-4 inline" /> : <ChevronDownIcon className="w-4 h-4 inline" />)}
      </th>
      <th
        className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider cursor-pointer"
        onClick={() => handleSort('po_number')}
      >
        PO # {sortField === 'po_number' && (sortDirection === 'asc' ? <ChevronUpIcon className="w-4 h-4 inline" /> : <ChevronDownIcon className="w-4 h-4 inline" />)}
      </th>
      <th
        className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider cursor-pointer"
        onClick={() => handleSort('package_number')}
      >
        PKG # {sortField === 'package_number' && (sortDirection === 'asc' ? <ChevronUpIcon className="w-4 h-4 inline" /> : <ChevronDownIcon className="w-4 h-4 inline" />)}
      </th>
      <th
        className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider cursor-pointer"
        onClick={() => handleSort('customer_nickname')}
      >
        Customer {sortField === 'customer_nickname' && (sortDirection === 'asc' ? <ChevronUpIcon className="w-4 h-4 inline" /> : <ChevronDownIcon className="w-4 h-4 inline" />)}
      </th>
      <th
        className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider cursor-pointer"
        onClick={() => handleSort('total_amount')}
      >
        Total {sortField === 'total_amount' && (sortDirection === 'asc' ? <ChevronUpIcon className="w-4 h-4 inline" /> : <ChevronDownIcon className="w-4 h-4 inline" />)}
      </th>
      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Status</th>
      <th
        className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider cursor-pointer"
        onClick={() => handleSort('net_due_date')}
      >
        Due {sortField === 'net_due_date' && (sortDirection === 'asc' ? <ChevronUpIcon className="w-4 h-4 inline" /> : <ChevronDownIcon className="w-4 h-4 inline" />)}
      </th>
      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Payment Details</th>
      <th
        className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider cursor-pointer"
        onClick={() => handleSort('created_at')}
      >
        Created {sortField === 'created_at' && (sortDirection === 'asc' ? <ChevronUpIcon className="w-4 h-4 inline" /> : <ChevronDownIcon className="w-4 h-4 inline" />)}
      </th>
      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Sent</th>
      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Actions</th>
    </tr>
  </thead>
  <tbody className="bg-white divide-y divide-gray-200">
    {filteredInvoices.map((inv) => {
      const isOverdue = inv.status === 'unpaid' && new Date(inv.net_due_date) < new Date();
      const isExpanded = expandedRows[inv.invoice_number] || false;
      const hasEmails = inv.email_logs && inv.email_logs.length > 0;
      return (
        <Fragment key={inv.invoice_number}>
          <tr className="hover:bg-gray-50 transition duration-150">
            <td
              className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
              onClick={() => toggleRow(inv.invoice_number)}
            >
              <button className="flex items-center text-indigo-600 hover:text-indigo-800">
                {inv.invoice_number}
              </button>
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{inv.po_number}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{inv.package_number}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{inv.customer_nickname}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">${inv.total_amount.toFixed(2)}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm">
              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${inv.status === 'paid' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                {inv.status.charAt(0).toUpperCase() + inv.status.slice(1)}
              </span>
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              <span className={isOverdue ? 'text-orange-600 font-medium' : 'text-gray-600'}>
                {new Date(inv.net_due_date).toLocaleDateString()} {isOverdue && '(Overdue)'}
              </span>
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {inv.status === 'paid' ? (
                <span className="text-sm text-gray-600">
                  {inv.payment_type} Ref #{inv.reference_number}, {new Date(inv.payment_date).toLocaleDateString()}
                </span>
              ) : (
                <span className="text-sm text-gray-500">-</span>
              )}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{new Date(inv.created_at).toLocaleDateString()}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {hasEmails ? (
                <button
                  onClick={() => {
                    setSelectedEmailHistory(inv.email_logs);
                    setIsEmailHistoryModalOpen(true);
                  }}
                  className="text-green-600 hover:text-green-800"
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </button>
              ) : (
                <span className="text-gray-500">-</span>
              )}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm flex space-x-2">
              <Menu as="div" className="relative inline-block text-left">
                <div>
                  <Menu.Button className="bg-indigo-600 text-white rounded-md px-2 py-1 text-sm font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Actions
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute -top-8 right-20 w-48 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
                    <div className="py-1">
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            onClick={() => openPdfModal(inv.pdf_path)}
                            className={`${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'} group flex items-center w-full px-4 py-2 text-sm transition duration-150`}
                          >
                            <EyeIcon className="w-5 h-5 mr-3 text-gray-500" />
                            Preview
                          </button>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            onClick={() => openEditModal(inv)}
                            className={`${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'} group flex items-center w-full px-4 py-2 text-sm transition duration-150`}
                          >
                            <BanknotesIcon className="w-5 h-5 mr-3 text-gray-500" />
                            Edit Invoice
                          </button>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            onClick={() => {
                              setSelectedInvoiceForEmail(inv);
                              setIsEmailModalOpen(true);
                            }}
                            className={`${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'} group flex items-center w-full px-4 py-2 text-sm transition duration-150`}
                          >
                            <DocumentArrowDownIcon className="w-5 h-5 mr-3 text-gray-500" />
                            Send Email
                          </button>
                        )}
                      </Menu.Item>
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            </td>
          </tr>
          {isExpanded && (
            <tr>
              <td colSpan="11" className="p-4 bg-gray-50">
                <div className="overflow-x-auto rounded-lg border-2">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="px-3 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Line #</th>
                        <th className="px-3 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Part Number</th>
                        <th className="px-3 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Description</th>
                        <th className="px-3 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">PO Number</th>
                        <th className="px-3 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Quantity</th>
                        <th className="px-3 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Unit Price</th>
                        <th className="px-3 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Total</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {inv.deliveries.length > 0 ? (
                        inv.deliveries.map((delivery, index) => (
                          <tr key={index}>
                            <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-900">{delivery.po_line_number || 'N/A'}</td>
                            <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-900">{delivery.part_number || 'N/A'}</td>
                            <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-900">{delivery.description || 'N/A'}</td>
                            <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-900">{delivery.po_number || 'N/A'}</td>
                            <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-900">{delivery.quantity || 'N/A'}</td>
                            <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-900">${(delivery.jobs?.unit_price || delivery.kanban_jobs?.unit_price || 0).toFixed(2)}</td>
                            <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-900">${(delivery.quantity * (delivery.jobs?.unit_price || delivery.kanban_jobs?.unit_price || 0)).toFixed(2)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="px-6 py-4 text-sm text-gray-500 text-center">
                            No line items available for this package.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          )}
        </Fragment>
      );
    })}
  </tbody>
</table>
        </div>

        {/* Create Invoice Modal */}
        <Transition appear show={isCreateModalOpen} as={Fragment}>
          <Dialog as="div" className="relative z-50" onClose={closeCreateModal}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-5xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                    <Dialog.Title as="h2" className="text-xl font-semibold text-gray-900 mb-4">
                      Create Invoice
                    </Dialog.Title>
                    <div className="space-y-6">
                      {/* Search and Package Selection */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Search Packages</label>
                        <input
                          type="text"
                          value={packageSearchQuery}
                          onChange={(e) => setPackageSearchQuery(e.target.value)}
                          placeholder="Search by package number"
                          className="block w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
                        />
                      </div>
                      <div className="overflow-x-auto max-h-96">
  <table className="min-w-full divide-y divide-gray-200">
    <thead className="bg-gray-50">
      <tr>
        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Package #</th>
        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">PO Number</th>
        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Customer</th>
        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Ship Date</th>
        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Total Quantity</th>
        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Total Amount</th>
        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Select</th>
      </tr>
    </thead>
    <tbody className="bg-white divide-y divide-gray-200">
      {filteredPackages.map((pkg) => (
        <tr key={pkg.package_number} className="hover:bg-gray-50 transition duration-150">
          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{pkg.package_number}</td>
          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{pkg.po_number}</td>
          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{pkg.customer_nickname}</td>
          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
            {pkg.deliveries[0]?.ship_date ? new Date(pkg.deliveries[0].ship_date).toLocaleDateString() : '-'}
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{pkg.total_quantity}</td>
          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">${pkg.total_amount.toFixed(2)}</td>
          <td className="px-6 py-4 whitespace-nowrap text-sm">
            <button
              onClick={() => setSelectedPackage(pkg)}
              className={`px-3 py-1 rounded-lg text-sm font-medium transition duration-200 ${selectedPackage?.package_number === pkg.package_number ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
             
            >
              {selectedPackage?.package_number === pkg.package_number ? 'Selected' : 'Select'}
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

                      {/* Package Preview */}
                      {selectedPackage && (
                        <div
                          initial={{ opacity: 0, height: 0 }}
                          animate={{ opacity: 1, height: 'auto' }}
                          exit={{ opacity: 0, height: 0 }}
                          transition={{ duration: 0.3 }}
                          className="border-t border-gray-200 pt-4"
                        >
                          <h3 className="text-lg font-semibold text-gray-900 mb-4">Package Preview: {selectedPackage.package_number}</h3>
                          <div className="space-y-4">
                            <p className="text-sm text-gray-600"><span className="font-medium">PO Number:</span> {selectedPackage.po_number}</p>
                            <p className="text-sm text-gray-600"><span className="font-medium">Customer:</span> {selectedPackage.customer.nickname}</p>
                            <div className="overflow-x-auto">
                              <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                  <tr>
                                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Line #</th>
                                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Part Number</th>
                                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Quantity</th>
                                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Unit Price</th>
                                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Total</th>
                                  </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                  {selectedPackage.deliveries.map((delivery, index) => (
                                    <tr key={index} className="hover:bg-gray-50 transition duration-150">
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{delivery.po_line_number}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{delivery.part_number}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{delivery.quantity}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">${(delivery.jobs?.unit_price || delivery.kanban_jobs?.unit_price || 0).toFixed(2)}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">${(delivery.quantity * (delivery.jobs?.unit_price || delivery.kanban_jobs?.unit_price || 0)).toFixed(2)}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                            <p className="text-sm font-medium text-gray-900"><span className="font-medium">Total Value:</span> ${selectedPackage.total_amount.toFixed(2)}</p>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="mt-6 flex justify-end space-x-3">
                      <button
                        onClick={closeCreateModal}
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition duration-200 shadow-sm"
                       
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleCreateInvoice}
                        className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition duration-200 shadow-sm disabled:bg-gray-400 disabled:cursor-not-allowed"
                        disabled={!selectedPackage}
                       
                      >
                        Create Invoice
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>

        {/* Record Payment Modal */}
        <Transition appear show={isPaymentModalOpen} as={Fragment}>
  <Dialog as="div" className="relative z-50" onClose={closePaymentModal}>
    <Transition.Child
      as={Fragment}
      enter="ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed inset-0 bg-black bg-opacity-25" />
    </Transition.Child>

    <div className="fixed inset-0 overflow-y-auto">
      <div className="flex min-h-full items-center justify-center p-4">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
            <Dialog.Title as="h2" className="text-xl font-semibold text-gray-900 mb-4">
              Record Payment for Invoice #{selectedInvoice?.invoice_number}
            </Dialog.Title>
            <div className="space-y-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Payment Type</label>
                <select
                  value={paymentType}
                  onChange={(e) => setPaymentType(e.target.value)}
                  className="block w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
                >
                  <option value="Check">Check</option>
                  <option value="Credit Card">Credit Card</option>
                  <option value="ACH">ACH</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Reference Number</label>
                <input
                  type="text"
                  value={referenceNumber}
                  onChange={(e) => setReferenceNumber(e.target.value)}
                  className="block w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
                  placeholder="Enter reference number"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Payment Date</label>
                <input
                  type="date"
                  value={paymentDate}
                  onChange={(e) => setPaymentDate(e.target.value)}
                  className="block w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
                />
              </div>
            </div>
            <div className="flex justify-end space-x-3">
              <button
                onClick={closePaymentModal}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition duration-200 shadow-sm"
               
              >
                Cancel
              </button>
              <button
                onClick={handleRecordPayment}
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition duration-200 shadow-sm"
                
              >
                Record Payment
              </button>
            </div>
          </Dialog.Panel>
        </Transition.Child>
      </div>
    </div>
  </Dialog>
</Transition>

        {/* PDF Viewer Modal */}
        <Transition appear show={isPdfModalOpen} as={Fragment}>
  <Dialog as="div" className="relative z-50" onClose={closePdfModal}>
    <Transition.Child
      as={Fragment}
      enter="ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed inset-0 bg-black bg-opacity-25" />
    </Transition.Child>

    <div className="fixed inset-0 overflow-y-auto">
      <div className="flex min-h-full items-center justify-center p-4">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Dialog.Panel className="w-[90vw] h-[90vh] max-w-[calc(100vw-2rem)] max-h-[calc(100vh-2rem)] transform rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
            <Dialog.Title as="h2" className="text-xl font-semibold text-gray-900 mb-4">
              Invoice Preview
            </Dialog.Title>
            <div className="mt-4 h-[calc(100%-6rem)] overflow-auto">
              {isPdfLoading ? (
                <p className="text-gray-500">Loading PDF...</p>
              ) : pdfLoadError ? (
                <p className="text-gray-500">
                  Unable to load PDF. It has been opened in a new tab.
                </p>
              ) : signedUrl ? (
                <iframe
                  src={signedUrl}
                  className="w-full h-full border border-gray-200 rounded-lg"
                  title="Invoice Preview"
                  onError={async () => {
                    setPdfLoadError(true);
                    toast.error('Failed to load PDF in preview. Opening in a new tab instead...');
                    try {
                      const { data: signedData, error: signedError } = await supabase.storage
                        .from('invoices')
                        .createSignedUrl(currentPdfPath, 300);
                      if (signedError) throw new Error(`Fallback signed URL failed: ${signedError.message}`);
                      console.log('Iframe fallback signed URL:', signedData.signedUrl);
                      window.open(signedData.signedUrl, '_blank');
                    } catch (signedErr) {
                      console.error('Error in iframe fallback signed URL:', signedErr);
                      toast.error(`Failed to open PDF in new tab: ${signedErr.message}`);
                    }
                  }}
                />
              ) : (
                <p className="text-gray-500">Unable to load PDF.</p>
              )}
            </div>
            <div className="mt-4 flex justify-end">
              <button
                onClick={closePdfModal}
                className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition duration-200 shadow-sm"
              >
                Close
              </button>
            </div>
          </Dialog.Panel>
        </Transition.Child>
      </div>
    </div>
  </Dialog>
</Transition>

        <Transition appear show={isEditModalOpen} as={Fragment}>
  <Dialog as="div" className="relative z-50" onClose={closeEditModal}>
    <Transition.Child
      as={Fragment}
      
    >
      <div className="fixed inset-0 bg-black bg-opacity-25" />
    </Transition.Child>

    <div className="fixed inset-0 overflow-y-auto">
      <div className="flex min-h-full items-center justify-center p-4">
        <Transition.Child
          as={Fragment}
         
        >
          <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
            <Dialog.Title as="h2" className="text-xl font-semibold text-gray-900 mb-4">
              Edit Invoice #{selectedInvoice?.invoice_number}
            </Dialog.Title>
            <div className="space-y-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
                <select
                  value={editStatus}
                  onChange={(e) => setEditStatus(e.target.value)}
                  className="block w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
                >
                  <option value="unpaid">Unpaid</option>
                  <option value="paid">Paid</option>
                </select>
              </div>
              {editStatus === 'paid' && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Payment Date</label>
                  <input
                    type="date"
                    value={editPaymentDate}
                    onChange={(e) => setEditPaymentDate(e.target.value)}
                    className="block w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
                  />
                </div>
              )}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Payment Type</label>
                <select
                  value={editPaymentType}
                  onChange={(e) => setEditPaymentType(e.target.value)}
                  className="block w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
                >
                  <option value="Check">Check</option>
                  <option value="Credit Card">Credit Card</option>
                  <option value="ACH">ACH</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Reference Number</label>
                <input
                  type="text"
                  value={editReferenceNumber}
                  onChange={(e) => setEditReferenceNumber(e.target.value)}
                  className="block w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
                  placeholder="Enter reference number"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Notes</label>
                <textarea
                  value={editNotes}
                  onChange={(e) => setEditNotes(e.target.value)}
                  className="block w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
                  placeholder="Enter notes (optional)"
                  rows="4"
                />
              </div>
            </div>
            <div className="flex justify-end space-x-3">
              <button
                onClick={handleDeleteInvoice}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition duration-200 shadow-sm"
               
              >
                Delete Invoice
              </button>
              <button
                onClick={closeEditModal}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition duration-200 shadow-sm"
                
              >
                Cancel
              </button>
              <button
                onClick={handleEditInvoice}
                className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition duration-200 shadow-sm"
                
              >
                Save Changes
              </button>
            </div>
          </Dialog.Panel>
        </Transition.Child>
      </div>
    </div>
  </Dialog>
</Transition>

{/* Email History Modal */}
<Transition appear show={isEmailHistoryModalOpen} as={Fragment}>
  <Dialog as="div" className="relative z-50" onClose={() => setIsEmailHistoryModalOpen(false)}>
    <Transition.Child
      as={Fragment}
      enter="ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed inset-0 bg-black bg-opacity-25" />
    </Transition.Child>

    <div className="fixed inset-0 overflow-y-auto">
      <div className="flex min-h-full items-center justify-center p-4">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Dialog.Panel className="w-full max-w-xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
            <Dialog.Title as="h2" className="text-xl font-semibold text-gray-900 mb-4">
              Email History for Invoice #{selectedEmailHistory[0]?.invoice_number}
            </Dialog.Title>
            <div className="space-y-4 max-h-96 overflow-y-auto">
              {selectedEmailHistory.length > 0 ? (
                selectedEmailHistory.map((log) => (
                  <div key={log.id} className="p-4 border border-gray-200 rounded-lg">
                    <p className="text-sm text-gray-600">
                      <span className="font-medium">Sent At:</span> {new Date(log.sent_at).toLocaleString()}
                    </p>
                    <p className="text-sm text-gray-600">
                      <span className="font-medium">Recipients:</span> {log.recipients.join(', ')}
                    </p>
                    <p className="text-sm text-gray-600">
                      <span className="font-medium">Status:</span>{' '}
                      <span className={log.status === 'sent' ? 'text-green-600' : 'text-red-600'}>
                        {log.status.charAt(0).toUpperCase() + log.status.slice(1)}
                      </span>
                    </p>
                    {log.error_message && (
                      <p className="text-sm text-gray-600">
                        <span className="font-medium">Error:</span> {log.error_message}
                      </p>
                    )}
                  </div>
                ))
              ) : (
                <p className="text-gray-500">No email history available.</p>
              )}
            </div>
            <div className="mt-4 flex justify-end">
              <button
                onClick={() => setIsEmailHistoryModalOpen(false)}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition duration-200 shadow-sm"
              >
                Close
              </button>
            </div>
          </Dialog.Panel>
        </Transition.Child>
      </div>
    </div>
  </Dialog>
</Transition>

{/* Send Email Modal */}
<Transition appear show={isEmailModalOpen} as={Fragment}>
  <Dialog as="div" className="relative z-50" onClose={() => {
    if (!isEmailLoading) {
      setIsEmailModalOpen(false);
      setEmailRecipients([]);
      setCurrentEmailInput('');
      setEmailSuccess(false);
      setSelectedInvoiceForEmail(null);
    }
  }}>
    <Transition.Child
      as={Fragment}
      enter="ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed inset-0 bg-black bg-opacity-25" />
    </Transition.Child>

    <div className="fixed inset-0 overflow-y-auto">
      <div className="flex min-h-full items-center justify-center p-4">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Dialog.Panel className="w-full max-w-xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
            <Dialog.Title as="h2" className="text-xl font-semibold text-gray-900 mb-4">
              Send Invoice #{selectedInvoiceForEmail?.invoice_number} via Email
            </Dialog.Title>

            {emailSuccess ? (
              <div className="mb-6 text-center">
                <svg
                  className="w-12 h-12 text-green-500 mx-auto mb-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <p className="text-green-600 font-medium">Email sent successfully!</p>
              </div>
            ) : (
              <div className="space-y-4 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Recipient Emails (comma, tab, space, or enter to add)
                  </label>
                  <div className="flex flex-wrap gap-2 p-2 border border-gray-300 rounded-lg focus-within:ring-2 focus-within:ring-indigo-500">
                    {emailRecipients.map((email, index) => (
                      <div
                        key={index}
                        className="flex items-center bg-indigo-100 text-indigo-800 text-sm font-medium px-2 py-1 rounded"
                      >
                        {email}
                        <button
                          onClick={() => {
                            setEmailRecipients(emailRecipients.filter((_, i) => i !== index));
                          }}
                          className="ml-2 text-indigo-600 hover:text-indigo-800"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                    <input
                      type="text"
                      value={currentEmailInput}
                      onChange={(e) => setCurrentEmailInput(e.target.value)}
                      onKeyDown={(e) => {
                        if ((e.key === ',' || e.key === 'Enter' || e.key === 'Tab' || e.key === ' ') && currentEmailInput.trim()) {
                          e.preventDefault();
                          const email = currentEmailInput.trim();
                          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                          if (emailRegex.test(email) && !emailRecipients.includes(email)) {
                            setEmailRecipients([...emailRecipients, email]);
                            setCurrentEmailInput('');
                          } else {
                            toast.error('Invalid or duplicate email address');
                          }
                        }
                      }}
                      className="flex-1 p-1 border-none focus:outline-none"
                      placeholder={
                        emailRecipients.length === 0
                          ? "Enter email addresses, separate with commas"
                          : "Add another email"
                      }
                      disabled={isEmailLoading}
                    />
                  </div>
                </div>
                {/* Customer Emails Section */}
                <div className="space-y-2">
                  <p className="text-sm font-medium text-gray-700">Customer Emails:</p>
                  <div className="flex flex-wrap gap-2">
                    {selectedInvoiceForEmail?.billing_contact_email && (
                      <button
                        onClick={() => {
                          const email = selectedInvoiceForEmail.billing_contact_email.trim();
                          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                          if (emailRegex.test(email) && !emailRecipients.includes(email)) {
                            setEmailRecipients([...emailRecipients, email]);
                          } else if (!emailRegex.test(email)) {
                            toast.error('Invalid billing email address');
                          } else {
                            toast.error('Billing email already added');
                          }
                        }}
                        className="text-sm text-indigo-600 hover:text-indigo-800 underline"
                        disabled={isEmailLoading}
                      >
                        Billing: {selectedInvoiceForEmail.billing_contact_email}
                      </button>
                    )}
                    {selectedInvoiceForEmail?.shipping_contact_email && (
                      <button
                        onClick={() => {
                          const email = selectedInvoiceForEmail.shipping_contact_email.trim();
                          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                          if (emailRegex.test(email) && !emailRecipients.includes(email)) {
                            setEmailRecipients([...emailRecipients, email]);
                          } else if (!emailRegex.test(email)) {
                            toast.error('Invalid contact email address');
                          } else {
                            toast.error('Contact email already added');
                          }
                        }}
                        className="text-sm text-indigo-600 hover:text-indigo-800 underline"
                        disabled={isEmailLoading}
                      >
                        Contact: {selectedInvoiceForEmail.shipping_contact_email}
                      </button>
                    )}
                    {!selectedInvoiceForEmail?.billing_contact_email && !selectedInvoiceForEmail?.shipping_contact_email && (
                      <p className="text-sm text-gray-500">No customer emails available.</p>
                    )}
                  </div>
                </div>
              </div>
            )}

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => {
                  setIsEmailModalOpen(false);
                  setEmailRecipients([]);
                  setCurrentEmailInput('');
                  setEmailSuccess(false);
                  setSelectedInvoiceForEmail(null);
                }}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition duration-200 shadow-sm"
                disabled={isEmailLoading}
              >
                {emailSuccess ? "Close" : "Cancel"}
              </button>
              {!emailSuccess && (
                <button
                  onClick={handleSendEmail}
                  className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition duration-200 shadow-sm flex items-center"
                  disabled={isEmailLoading || emailRecipients.length === 0}
                >
                  {isEmailLoading ? (
                    <>
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                        />
                      </svg>
                      Sending...
                    </>
                  ) : (
                    "Send Email"
                  )}
                </button>
              )}
            </div>
          </Dialog.Panel>
        </Transition.Child>
      </div>
    </div>
  </Dialog>
</Transition>
      </div>

      <Transition appear show={isExportModalOpen} as={Fragment}>
  <Dialog as="div" className="relative z-50" onClose={closeExportModal}>
    <Transition.Child
      as={Fragment}
      enter="ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed inset-0 bg-black bg-opacity-25" />
    </Transition.Child>

    <div className="fixed inset-0 overflow-y-auto">
      <div className="flex min-h-full items-center justify-center p-4">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
            <Dialog.Title as="h2" className="text-xl font-semibold text-gray-900 mb-4">
              Export Invoice Report
            </Dialog.Title>
            <div className="space-y-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">File Type</label>
                <select
                  value={fileType}
                  onChange={(e) => setFileType(e.target.value)}
                  className="block w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
                  disabled={isGeneratingExport}
                >
                  <option value="CSV">CSV</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Customer</label>
                <select
                  value={selectedCustomerForExport}
                  onChange={(e) => setSelectedCustomerForExport(e.target.value)}
                  className="block w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
                  disabled={isGeneratingExport}
                >
                  <option value="all">All Customers</option>
                  {getUniqueCustomers().map((customer) => (
                    <option key={customer.customer_id} value={customer.customer_id}>
                      {customer.customer_nickname}
                    </option>
                  ))}
                </select>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg">
                <p className="text-sm text-gray-600">
                  <span className="font-medium">Export will include:</span> Invoice number, customer, package number, PO number, quantities, amounts, status, dates, and payment details.
                </p>
              </div>
            </div>
            <div className="flex justify-end space-x-3">
              <button
                onClick={closeExportModal}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition duration-200 shadow-sm"
                disabled={isGeneratingExport}
              >
                Cancel
              </button>
              <button
                onClick={handleGenerateExport}
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition duration-200 shadow-sm flex items-center"
                disabled={isGeneratingExport}
              >
                {isGeneratingExport ? (
                  <>
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                      />
                    </svg>
                    Generating...
                  </>
                ) : (
                  <>
                    <DocumentArrowDownIcon className="w-5 h-5 mr-2" />
                    Generate
                  </>
                )}
              </button>
            </div>
          </Dialog.Panel>
        </Transition.Child>
      </div>
    </div>
  </Dialog>
</Transition>
    </div>
  );
}

export default Invoices;